import { render, staticRenderFns } from "./ApprovedAlert.vue?vue&type=template&id=30088e69"
import script from "./ApprovedAlert.vue?vue&type=script&lang=js"
export * from "./ApprovedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports